import React from 'react';
import { Box, Typography } from '@mui/material';

import { useSalonPublicTheme } from '../../../context/SalonPublicThemeContext';


const SalonPublicGallery = ({
  photos = [],
  emptyLabel,
  compact = false,
  sx,
}) => {
  const { tokens: theme } = useSalonPublicTheme();
  const visiblePhotos = photos.filter((photo) => photo?.src).slice(0, compact ? 3 : 5);

  return (
    <Box
      data-testid="salon-public-gallery"
      data-compact={String(compact)}
      sx={{
        display: 'grid',
        gridTemplateColumns: visiblePhotos.length > 1
          ? { xs: '1fr', sm: '2fr 1fr' }
          : '1fr',
        gridAutoRows: compact ? 96 : { xs: 160, sm: 220 },
        gap: compact ? 1 : 1.5,
        minHeight: compact ? 96 : 160,
        overflow: 'hidden',
        borderRadius: 3,
        bgcolor: theme.salon.surface,
        border: '1px solid',
        borderColor: theme.salon.border,
        ...sx,
      }}
    >
      {visiblePhotos.length === 0 ? (
        <Box sx={{ display: 'grid', placeItems: 'center', minHeight: compact ? 96 : 160 }}>
          <Typography variant="body2" color="text.secondary">
            {emptyLabel}
          </Typography>
        </Box>
      ) : visiblePhotos.map((photo, index) => (
        <Box
          key={`${photo.src}-${index}`}
          component="img"
          data-testid="salon-public-gallery-photo"
          src={photo.src}
          alt={photo.alt || ''}
          sx={{
            width: '100%',
            height: '100%',
            minHeight: 0,
            objectFit: 'cover',
            gridRow: index === 0 && visiblePhotos.length > 1 ? 'span 2' : 'auto',
          }}
        />
      ))}
    </Box>
  );
};

export default SalonPublicGallery;
